import { render, staticRenderFns } from "./MorePopover.vue?vue&type=template&id=733afe49&scoped=true"
import script from "./MorePopover.vue?vue&type=script&lang=js"
export * from "./MorePopover.vue?vue&type=script&lang=js"
import style0 from "./MorePopover.vue?vue&type=style&index=0&id=733afe49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733afe49",
  null
  
)

export default component.exports